module.exports = __webpack_public_path__ + "img/contactus_icon_fb.7f9e82b9.svg";